export function formatUsd(
  value: string | number | null | undefined,
  options?: { decimals?: number }
): string | null {
  if (value == null || value === "") return null;
  const amount = Number(value);
  if (!Number.isFinite(amount)) return null;
  const requested = options?.decimals ?? (Math.abs(amount) < 0.01 ? 6 : 4);
  const decimals = amount !== 0 && Number(amount.toFixed(requested)) === 0 ? 8 : requested;
  return `$${amount.toFixed(decimals)}`;
}

export function formatTimestamp(
  value: string | null | undefined,
  options?: { locale?: string }
): string | null {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString(options?.locale);
}

export function formatResolution(width: unknown, height: unknown): string | null {
  const w = asFiniteNumber(width);
  const h = asFiniteNumber(height);
  return w && h ? `${w}×${h}` : null;
}

export function formatDuration(seconds: unknown): string | null {
  const value = asFiniteNumber(seconds);
  return value == null ? null : `${Math.round(value * 100) / 100}s`;
}

export function displayValue(value: unknown): string | null {
  if (typeof value === "string" && value.trim()) return value;
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  return null;
}

export function summarizeParamValue(value: unknown): string {
  if (Array.isArray(value)) return `${value.length} reference${value.length === 1 ? "" : "s"}`;
  if (typeof value === "boolean") return value ? "On" : "Off";
  if (value && typeof value === "object") return JSON.stringify(value);
  return String(value);
}

function asFiniteNumber(value: unknown): number | null {
  return typeof value === "number" && Number.isFinite(value) ? value : null;
}
